import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

import App from '@/App';
import { initializeSentry } from '@/app/sentry';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import '@/i18n';
import './index.scss';
import { AppProviders } from '@/providers/AppProviders';

ModuleRegistry.registerModules([AllCommunityModule]);

initializeSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </StrictMode>,
);
